import { Button, TYPE } from '@common/Button/Button';
import { getLocale } from '@libs/constants';
import { EXTERNAL_LINKS } from '@libs/redirect.helper';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import type { ReactElement } from 'react';

export enum ShoppingCartModalContentMode {
  ADD_ARTICLE,
  ADD_CONFIGURATION,
  UPDATE_CONFIGURATION,
}

interface ShoppingCartModalContentProps {
  onClose: () => void;
  mode: ShoppingCartModalContentMode;
  additionalContent?: ReactElement;
}

export const ShoppingCartModalContent = ({
  onClose,
  mode = ShoppingCartModalContentMode.ADD_ARTICLE,
  additionalContent,
}: ShoppingCartModalContentProps) => {
  const { t } = useTranslation('product/buyBox');
  const router = useRouter();
  const locale = getLocale(router);

  let translationKey: string;

  switch (mode) {
    case ShoppingCartModalContentMode.ADD_ARTICLE:
      translationKey = 'BUY_BOX.ADD_TO_SHOPPING_CART_SUCCESS_MODAL';
      break;
    case ShoppingCartModalContentMode.ADD_CONFIGURATION:
      translationKey = 'BUY_BOX.ADD_CONFIGURATION_TO_SHOPPING_CART_SUCCESS_MODAL';
      break;
    case ShoppingCartModalContentMode.UPDATE_CONFIGURATION:
      translationKey = 'BUY_BOX.UPDATE_CONFIGURATION_IN_SHOPPING_CART_SUCCESS_MODAL';
      break;
    default:
      translationKey = 'BUY_BOX.ADD_TO_SHOPPING_CART_SUCCESS_MODAL';
  }

  return (
    <>
      <p
        data-testid="cart-success-modal-text"
        className="mt-8 mb-12 text-base"
        dangerouslySetInnerHTML={{
          __html: t(translationKey),
        }}
      />

      {additionalContent}

      <div className="flex justify-between mt-20">
        <Button
          testId="cart-success-modal-close"
          text={t('BUY_BOX.ADD_TO_SHOPPING_CART_SUCCESS_MODAL_CONTINUE_BUTTON')}
          className="mr-4"
          onClick={() => {
            onClose();
          }}
          type={TYPE.SECONDARY}
        />
        <Button
          type={TYPE.PRIMARY}
          text={t('BUY_BOX.ADD_TO_SHOPPING_CART_SUCCESS_MODAL_CART_BUTTON')}
          href={EXTERNAL_LINKS.CART(locale)}
          testId="goto-shopping-cart"
        />
      </div>
    </>
  );
};
